exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".set-middle-dialog .el-dialog__body{height:400px!important}", ""]);

// exports
